export default "__VITE_ASSET__hqwVU_6M__"